var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"referrals-earnings"},[_c('h1',[_vm._v("Referral Earnings")]),_c('p',[_vm._v("Track your referral earnings here")])])
}]

export { render, staticRenderFns }